import { Component, OnInit, ViewChild } from "@angular/core";
import { FiltersComponent } from "src/app/shared/filters/filters.component";
import { TableComponent } from "src/app/shared/table/table.component";
import { Fsplaca, FsplacaListMapped } from "../../models/fsplaca.model";
import { FilterConstants } from "src/app/constants/filterConstants";
import { TableConstants } from "src/app/constants/tableConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import {
  Options,
  OptionsOutTable,
} from "src/app/shared/filters/models/filters.model";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TokenService } from "src/app/core/services/token.service";
import { CommonService } from "src/app/core/services/common.service";
import { FsplacaService } from "../../fsplaca.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";

@Component({
  selector: "app-list-fsplaca",
  templateUrl: "./list-fsplaca.component.html",
  styleUrls: ["./list-fsplaca.component.sass"],
})
export class ListFsplacaComponent implements OnInit {
  @ViewChild("outTable") filtersOutTable: FiltersComponent;
  @ViewChild("insideTable") filtersInsideTable: FiltersComponent;
  @ViewChild("table") table: TableComponent;

  public placasList: FsplacaListMapped[];
  filtersTable: string;
  filtersTableJSON;
  filtersSearch = "";
  filterList = FilterConstants.fsPlaca;
  tableList = TableConstants.fsPlaca;
  routing = RoutingConstants.fsPlaca;
  public options: Options = TableConstants.NotShowCreateDeleteAndArrowUpDown;
  filterListOutTable = FilterConstants.fsPlacaOuttable;
  filtersSearchOutTable = "";
  public optionsFiltersOutTable: OptionsOutTable = {
    isOutTable: true,
    showFilters: false,
    style: { "min-width": "1135px" },
    showCheckbox: false,
  };
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  placasLoaded: boolean = false;
  showTableFilter: boolean = false;
  showFiltersOut: boolean = false;
  showFilterButtons: boolean = false;
  titleFilters = "PR'S";

  constructor(
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private fsplacaService: FsplacaService,
    private translateService: TranslateService,
    private tokenService: TokenService,
    private commonService: CommonService,
    private sweetAlertService: SweetAlertService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "fs_placmye",
      ScreenConstants.admSistemas.fsPlaca
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.filtersSearch = this.filtersTableStateService.composeFiltersInTable(
      this.filterList
    );
    this.filtersSearchOutTable =
      this.filtersTableStateService.composeFiltersOutTable(
        this.filterListOutTable
      );
  }

  ngOnInit(): void {
    this.getList();
  }

  public getList() {
    let filters = this.commonService.concatThreeFilters(
      this.filtersTable,
      this.filtersSearch,
      this.filtersSearchOutTable
    );
    this.sweetAlertService.sweetAlertLoading();
    this.fsplacaService.list(filters).subscribe(
      (data) => {
        this.placasList = data["content"];
        this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
        this.numElements = data["numberOfElements"];
        this.totalElements = data["totalElements"];
        if (data["content"] && data["content"].length == 0) {
          let message = this.translateService.instant(
            "messages.notFoundResutls"
          );
          this.toastrAlertService.toastrWarning(message);
          this.numPages = 1;
        }
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  public toggleFilterButtons(item: boolean) {
    this.showFiltersOut = item;
    if (this.showFiltersOut) {
      this.showFilterButtons = true;
    } else if (!this.showTableFilter) {
      this.showFilterButtons = false;
    }
  }

  public showFilters(type: string) {
    if (type === "normal") {
      this.showTableFilter = true;
    }
    this.showFilterButtons = true;
  }

  public filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
    this.getList();
  }

  public buttonsHeader(item: string) {
    switch (item) {
      case "erase":
        this.filtersInsideTable.filtersSelectorSearch = [];
        this.filtersInsideTable.filtersValuesSearch = [];
        this.filtersOutTable.filtersSelectorSearch = [];
        this.filtersOutTable.filtersValuesSearch = [];
        this.filtersInsideTable.cleanSelectorAndDates();
        this.filtersOutTable.cleanSelectorAndDates();
        break;
      case "search":
        this.filtersSearch = this.filtersInsideTable.composeParams();
        this.filtersSearchOutTable = this.filtersOutTable.composeParams();
        this.filtersTableStateService.setPageState(0);
        this.filtersTableJSON =
          this.filtersTableStateService.getFiltersTableState();
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.getList();
        break;
      case "toggleFilters":
        if (this.showTableFilter) {
          this.showTableFilter = false;
          if (!this.showFiltersOut) {
            this.showFilterButtons = false;
          }
        } else {
          this.showTableFilter = true;
          this.showFilterButtons = true;
        }
        break;
    }
  }
}
